export const NO_LICENCE_SHARING = [
    { value: 'NEXTBIKE', label: 'Nextbike', sublabel: 'Bikesharing', trackingLabel: 'Nextbike', iconType: 'Bike', image: `${process.env.BASE_URL}/images/transport-mode-icons/sharing/nextbike.png` },
    { value: 'TIER', label: 'Tier', sublabel: 'E-Scooter Sharing', trackingLabel: 'Tier', iconType: 'Scooter', image: `${process.env.BASE_URL}/images/transport-mode-icons/sharing/tier.png` },
    { value: 'CITYBIKE', label: 'Citybike', sublabel: 'Bikesharing', trackingLabel: 'Citybike', iconType: 'Bike', image: `${process.env.BASE_URL}/images/transport-mode-icons/sharing/citybike.png` },
]

export const LICENCE_SHARING = [
    { value: 'FLOMOBIL', label: 'Flomobil', sublabel: 'Carsharing', trackingLabel: 'Flomobil', image: `${process.env.BASE_URL}/images/transport-mode-icons/sharing/flomobil.png` },
    { value: 'CARUSO', label: 'Caruso', sublabel: 'Carsharing', trackingLabel: 'Caruso', image: `${process.env.BASE_URL}/images/transport-mode-icons/sharing/caruso.png` },
]

export const SHARING_MEANS_OF_TRANSPORT = [
    ...NO_LICENCE_SHARING,
    ...LICENCE_SHARING
]